import { Flex } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { NavLink } from 'react-router-dom'
import { get } from 'styled-system'
import { theme } from '../../../theme'

const MotionLink = motion.custom(NavLink)

type MenuItemProps = {
  color?: string
  bg?: string
  accentcolor?: string
  hovercolor?: string
}

const { colors } = theme

export const Tooltip = styled(Flex)`
  opacity: 0;
  left: 70px;
  border-radius: 5px;
  visibility: hidden;
  position: absolute;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transform: translateX(10px);
  &:after {
    top: 50%;
    width: 0;
    margin: 0;
    height: 0;
    left: -5px;
    content: '';
    line-height: 0;
    position: absolute;
    transform: translateY(-50%);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid ${theme.colors.gray[800]};
  }
`

export const MenuItem = styled(MotionLink)<MenuItemProps>`
  height: 52px;
  padding-left: 20px;
  display: flex;
  position: relative;
  align-self: stretch;
  align-items: center;
  white-space: nowrap;
  background: ${(props) => props.accentcolor};
  justify-content: flex-start;
  transition: background 0.2s ease;
  &.active-nav-link {
    background: #1e53691a;
    font-weight: 600;
    color: #115264;
  }
  &.active-nav-link::before {
    background: #ffffff;
    top: 0;
    left: 0;
    bottom: 0;
    width: 5px;
    content: '';
    position: absolute;
    font-weight: 400;
    color: #115264;
  }
  & .icon-wrap svg {
    stroke: ${theme.colors.black};
  }
  &:hover {
    cursor: pointer;
    transition: background 0.2s ease;
    background: ${(props) => get(colors, props.hovercolor || '', props.hovercolor || 'pink')};
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    color: #115264;
    font-weight: 600;
  }
  &:hover .sidebar-tooltip {
    opacity: 1;
    width: auto;
    padding: 5px 10px;
    visibility: visible;
    transform: translateX(0);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`
